import React, { lazy } from "react";
import Settings from "src/Screens/Client/Settings";

//Dashboard
const Dashboard = lazy(() => import('src/Screens/Client/Dashboard'));
//Calendar
const Calendar = lazy(() => import('src/Screens/Client/Calendar'));
//Sessions
const newSession = lazy(() => import('src/Screens/Client/Sessions/new'));
const listSession = lazy(() => import('src/Screens/Client/Sessions/list'));
//Goals
const Goals = lazy(() => import('src/Screens/Client/Goals'));
//Mensajes
const Messages = lazy(() => import('src/Screens/Client/Messages'));
//Mensajes
const Actions = lazy(() => import('src/Screens/Client/Actions'));
//Mensajes
const Resources = lazy(() => import('src/Screens/Client/Resources'));
const resourcesView = lazy(() => import('src/Screens/Coach/Resources/view'));
//Mensajes
const Notes = lazy(() => import('src/Screens/Client/Notes'));
//Profile
const profileDetail = lazy(() => import('src/Screens/Client/Profile/detail'));
const profileInfo = lazy(() => import('src/Screens/Client/Profile/info'));
const profileContact = lazy(() => import('src/Screens/Client/Profile/contact'));
// [023] Sección "Quién Soy / Acerca de mí" deshabilitada — código conservado.
// const profileAbout = lazy(() => import('src/Screens/Client/Profile/about'));
const profileAccount = lazy(() => import('src/Screens/Client/Profile/account'));
const profileNotifications = lazy(() => import('src/Screens/Client/Profile/notifications'));

//Coach
const Coach = lazy(() => import('src/Screens/Client/Coach'));
//Notifications
const Notifications = lazy(() => import('src/Screens/Shared/Notifications'));

//Ending
const endingView= lazy(() => import('src/Screens/Shared/Ending'));

//Guides
const guides = lazy(() => import('src/Screens/Guides'));

const routesClient = [
    {
        path: "/dashboard",
        element: Dashboard,
        isPrivate: true,
        exact: true
    },
    {
        path: "/calendar",
        element: Calendar,
        isPrivate: true,
        exact: true
    },
    {
        path: "/session/new",
        element: newSession,
        isPrivate: true,
        exact: true
    },
    {
        path: "/session/new/:selectedDate",
        element: newSession,
        isPrivate: true,
        exact: true
    },
    {
        path: "/sessions/:itemId/:type",
        element: listSession,
        isPrivate: true,
        exact: true
    },
    {
        path: "/goals",
        element: Goals,
        isPrivate: true,
        exact: true
    },
    {
        path: "/goals/:itemId/:type",
        element: Goals,
        isPrivate: true,
        exact: true
    },
    {
        path: "/messages",
        element: Messages,
        isPrivate: true,
        exact: true
    },
    {
        path: "/actions",
        element: Actions,
        isPrivate: true,
        exact: true
    },
    {
        path: "/actions/:itemId/:type",
        element: Actions,
        isPrivate: true,
        exact: true
    },
    // {
    //     path: "/notes",
    //     element: Notes,
    //     isPrivate: true,
    //     exact: true
    // },
    // {
    //     path: "/notes/:itemId/:type",
    //     element: Notes,
    //     isPrivate: true,
    //     exact: true
    // },
    {
        path: "/resources/:itemId/:type",
        element: Resources,
        isPrivate: true,
        exact: true
    },
    {
        path: "/resources",
        element: Resources,
        isPrivate: true,
        exact: true
    },
    {
        path: "/resource/view/:resourceId",
        element: resourcesView,
        isPrivate: true,
        exact: true
    },
    {
        path: "/profile",
        element: profileDetail,
        isPrivate: true,
        exact: true
    },
    {
        path: "/profile/info",
        element: profileInfo,
        isPrivate: true,
        exact: true
    },
    {
        path: "/profile/contact",
        element: profileContact,
        isPrivate: true,
        exact: true
    },
    // [023] Sección "Quién Soy / Acerca de mí" deshabilitada (inaccesible) — código conservado.
    // {
    //     path: "/profile/about",
    //     element: profileAbout,
    //     isPrivate: true,
    //     exact: true
    // },
    {
        path: "/profile/account",
        element: profileAccount,
        isPrivate: true,
        exact: true
    },
    {
        path: "/profile/notifications",
        element: profileNotifications,
        isPrivate: true,
        exact: true
    },
    {
        path: "/settings",
        element: Settings,
        isPrivate: true,
        exact: true
    },
    {
        path: "/notifications",
        element: Notifications,
        isPrivate: true,
        exact: true
    },
    {
        path: "/coach",
        element: Coach,
        isPrivate: true,
        exact: true
    },
    {
        path: "/ending",
        element: endingView,
        isPrivate: true,
        exact: true
    },
    {
        path: "/ending/:sessionId",
        element: endingView,
        isPrivate: true,
        exact: true
    },
    {
        path: "/guides",
        element: guides,
        isPrivate: true,
        exact: true
    }
];

export default routesClient;